













import { Component, Prop, Vue } from 'vue-property-decorator'
import { IBlogItem } from '../../../prismic'

@Component({})
export default class ArticleSummary extends Vue {
  @Prop()
  article: IBlogItem

  get thumbnail(): string {
    if (!this.article.data.hero.preview) return ''

    return this.article.data.hero.preview.url
  }
}
